import { style, media } from 'typestyle'
import { important } from 'csx'
export const pl4mdi = style(media({ maxWidth: 768 }, { paddingLeft: important('4px') }))
